import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div`
  padding: 13px 20px;
  display: flex;
  align-items: center;
  gap: 10px 0;
  background: var(--filter-bar-bg);
  flex-wrap: wrap;
  justify-content: space-between;

  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 10px;
      border-left: 0.5px solid #cdcfd0;

      :nth-child(1) {
        border: none;
      }
      &.btn-wrapper {
        button {
          border: 1px solid #bc9b6a;
          border-radius: 6px;
          color: #fff;
          background-color: transparent;
          min-height: 30px;
          &.active {
            background-color: #bc9b6a;
          }
        }
      }
    }
  }
  .header-checkbox-wrapper {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding-right: 18px;
    .MuiFormControlLabel-root {
      margin: 0;
    }
    .MuiFormControlLabel-label {
      font-size: 13px;
      line-height: 150.5%;
      color: #1d1d1d;
    }
    .MuiCheckbox-root {
      padding: 7.5px 9px;
    }
  }
  .MuiSelect-select {
    padding: 6.5px 14px;
    font-size: 14px;
    line-height: 150.5%;
    color: #fff;
  }
  .MuiSvgIcon-root {
    color: #fff;
    width: 17px;
  }
  .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #fff;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: #fff;
  }
  .icon-btn {
    background: #ffffff;
    border: 1px solid #636f7c;
    border-radius: 6px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .refresh-btn {
    border-color: #fff;
    color: #fff;
    :disabled {
      opacity: 0.5;
    }
  }
  .refresh-btn-color {
    border-color: #fff;
    background-color: #bc9b6a;
    color: #fff;
  }
`;

export const BodyWrapper = styled.div`
  padding: 28px 30px;
  max-height: calc(100vh - 128px);
  overflow: auto;
  .no-data{
    text-align: center;
  }
`;

export const Row = styled.div`
  margin-bottom: 30px;
  .row-header {
    background: #ffffff;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 0px 0px;
    padding: 0 50px;
    min-height: 70px;
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr 1.3fr 1fr 1fr;
    p {
      padding: 18px 10px;
      font-size: 16px;
      line-height: 150.5%;
    }
    .checkbox-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .row-body {
    background: #f4f4d4;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 0px 0px 10px 10px;
    .checkbox-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .table-body-data {
      display: grid;
      padding: 0 50px;
      min-height: 148px;
      grid-template-columns: 1fr 1fr 1.3fr 1fr 1fr;
      .un-active {
        opacity: 0.4;
        cursor: default;
      }
      .flex {
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          p {
            padding: 0;
            font-size: 10px;
          }
        }
      }
      .check-btn {
        padding: 0;
        border: navajowhite;
        background: transparent;
        height: auto;
      }
      .p-0 {
        padding: 0;
      }
      p {
        font-weight: 500;
        font-size: 24px;
        line-height: 150.5%;
        padding: 18px 10px;
        color: #0a0a0a;
        word-break: break-all;
        :nth-child(4) {
          align-self: center;
          /* color: #666666; */
          font-size: 54px;
          line-height: 150.5%;
        }
      }
    }
  }
`;

export const AccordionWrapper = styled.div`
  .table-accordion-detail {
    background-color: #fff;
  }
  .MuiPaper-root {
    display: flex;
    flex-direction: column;
    background: #f4f4d4;

    > .MuiButtonBase-root {
      display: inline-flex;
      margin-left: auto;
      background: linear-gradient(90deg, #bc9b6a 9.9%, #947550 100%);
      border: 0.5px solid #ffffff;
      box-shadow: 0px 10px 25px rgba(211, 190, 159, 0.5);
      border-radius: 6px;
      min-height: 43px;
      .Mui-expanded {
        margin: 9px 0;
        color: #fff;
      }
    }
  }
`;

export const TableWrapper = styled.div`
  padding: 36px 48px 28px;
  table {
    max-width: 1300px;
    width: 100%;
    border-collapse: collapse;
    .small {
      font-size: smaller;
    }
    thead {
      background: linear-gradient(180deg, #c2ac71 0%, #f4f4d4 100%);
      border: 1px solid #c2ac71;
      height: 62px;
    }
    tbody {
      border: 1px dashed rgba(0, 0, 0, 0.6);

      tr {
        border: 1px dashed rgba(0, 0, 0, 0.6);
        height: 51px;
      }
    }

    tr {
      th {
        text-align: left;
        font-weight: 400;
        padding: 0 10px;
        font-size: 16px;
        line-height: 150.5%;
        :first-child {
          padding-left: 40px;
        }
        :last-child {
          padding-right: 40px;
        }
        :last-child,
        :nth-last-child(2) {
          text-align: right;
        }
      }
      td {
        padding: 0 10px;
        font-weight: 500;
        font-size: 24px;
        line-height: 150.5%;
        :first-child {
          padding-left: 40px;
        }
        :last-child {
          padding-right: 40px;
        }
        :last-child,
        :nth-last-child(2) {
          text-align: right;
        }
      }
    }
    .table-body {
    }
  }
`;
